import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"
import { useQuery } from "@tanstack/react-query"
import { WhoWillReceiveCareValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"

const usePartnerExpenseEligibility = () => {
  return useQuery<{ legalPartnerEligible: boolean; nonLegalPartnerEligible: boolean }, ResponseError>({
    queryKey: ["partnerExpenseEligibility"],
    queryFn: () => carrotClient.getPartnerExpenseEligibility(),
    retry: buildCarrotApiRetryPolicy(3)
  })
}

type UseWhoWillReceiveCareEligibility = {
  checkPartnerEligibility: (whoReceivedCare: string) => "ELIGIBLE" | "INELIGIBLE"
  isLoading: boolean
}

export function useWhoWillReceiveCareEligibility(): UseWhoWillReceiveCareEligibility {
  const partnerExpenseEligibilityQuery = usePartnerExpenseEligibility()
  const { legalPartnerEligible, nonLegalPartnerEligible } = partnerExpenseEligibilityQuery?.data || {}

  const checkPartnerEligibility = (whoReceivedCare: string): "ELIGIBLE" | "INELIGIBLE" => {
    if (
      (whoReceivedCare === WhoWillReceiveCareValues.LEGAL_PARTNER && !legalPartnerEligible) ||
      (whoReceivedCare === WhoWillReceiveCareValues.NON_MARRIED_PARTNER && !nonLegalPartnerEligible)
    ) {
      return "INELIGIBLE"
    }

    return "ELIGIBLE"
  }

  return {
    checkPartnerEligibility,
    isLoading: partnerExpenseEligibilityQuery.isLoading
  }
}
